import React, { useState } from 'react';
import ProductModal from './ProductModal';
import { Document } from '@contentful/rich-text-types';
import { useContentful } from '../contentful/ContentContext';
import './Product.scss';

type ProductProps = {
  product: {
    name: string;
    price: number;
    richDescription: Document;
    numberOfItemsInStock?: number;
    category?: string;
    mainImage: {
      fields: {
        file: {
          url: string;
        };
      };
      title: string;
      richDescription: string;
    };
  };
};

const Product = ({ product }: ProductProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getUiText } = useContentful();

  return (
    <>
      <div className={'productWrapper'} onClick={() => setIsModalOpen(true)}>
        <img
          className={'image'}
          alt={product?.mainImage?.title}
          src={`https://${product?.mainImage?.fields?.file?.url}`}
        />
        <div className={'productInfo'}>
          <div className={'productLeft'}>
            {product?.category && (
              <p className={'productCategory'}>{product.category}</p>
            )}
            <h2 className={'productName'}>{product?.name}</h2>
          </div>
          <div className={'productRight'}>
            <p className={'productPrice'}>{product?.price} kr</p>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ProductModal product={product} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};

export default Product;
